import { useEffect, useState } from "react";
import api from "@/lib/api";

let cached = null;

export function usePublicConfig() {
  const [config, setConfig] = useState(cached || { trialDays: 14, freeModuleLimit: 2 });
  useEffect(() => {
    if (cached) return;
    api
      .get("/config")
      .then(({ data }) => {
        cached = data;
        setConfig(data);
      })
      .catch(() => {});
  }, []);
  return config;
}
